import React from 'react';

const MailOpenTableDetails = ({ mailOpenDetails, currentPage, itemsPerPage, paginate, formatDate }) => {
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = mailOpenDetails.slice(indexOfFirstItem, indexOfLastItem);
  
  const totalPages = Math.ceil(mailOpenDetails.length / itemsPerPage);

  return (
    <div className="overflow-x-auto">
      <h3 className="text-xl font-semibold mb-4 text-gray-800">Open Count History</h3>
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gradient-to-r from-blue-500 to-purple-600">
            <th className="px-4 py-3 text-left text-sm font-semibold text-white">No.</th>
            <th className="px-4 py-3 text-left text-sm font-semibold text-white">Clicked On</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.length > 0 ? (
            currentItems.map((mailOpenDetail, index) => (
              <tr key={index} className="hover:bg-gray-50 border-b">
                <td className="px-4 py-3 text-gray-800">
                  {(currentPage - 1) * itemsPerPage + index + 1}
                </td>
                <td className="px-4 py-3 text-gray-800">{formatDate(mailOpenDetail.clickedOn)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="2" className="text-center py-4 text-gray-600">
                No details available.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2 mt-4">
          <button
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Previous
          </button>

          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index}
              onClick={() => paginate(index + 1)}
              className={`px-4 py-2 text-sm font-medium rounded-lg border 
                ${currentPage === index + 1
                  ? 'bg-blue-500 text-white border-blue-500'
                  : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                }`}
            >
              {index + 1}
            </button>
          ))}

          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default MailOpenTableDetails;
